import { IconProps } from "../types";

export const SuccessIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 4C9.33333 4 4 9.33333 4 16C4 22.6667 9.33333 28 16 28C22.6667 28 28 22.6667 28 16C28 9.33333 22.6667 4 16 4ZM16 25.3333C10.8 25.3333 6.66667 21.2 6.66667 16C6.66667 10.8 10.8 6.66667 16 6.66667C21.2 6.66667 25.3333 10.8 25.3333 16C25.3333 21.2 21.2 25.3333 16 25.3333ZM21.0667 12.1333C21.6 12.6667 21.6 13.4667 21.0667 14L15.3333 19.7333C15.0667 20 14.6667 20.1333 14.4 20.1333C14.1333 20.1333 13.7333 20.1333 13.4667 19.7333L10.8 17.0667C10.2667 16.5333 10.2667 15.7333 10.8 15.2C11.3333 14.6667 12.1333 14.6667 12.6667 15.2L14.4 16.9333L19.2 12.1333C19.7333 11.6 20.5333 11.6 21.0667 12.1333Z"
        fill={fillColor ?? "#00A195"}
      />
    </svg>
  );
};
